<script setup lang="ts">
import type { UiTone, UiSize } from '~/utils/ui'
withDefaults(
  defineProps<{
    variant?: 'solid' | 'soft' | 'outline' | 'ghost' | 'chrome'
    tone?: UiTone
    size?: UiSize
    disabled?: boolean
    loading?: boolean
    fullWidth?: boolean
    type?: 'button' | 'submit' | 'reset'
  }>(),
  {
    disabled: undefined,
    loading: undefined,
    fullWidth: undefined,
    variant: 'solid',
    tone: 'accent',
    size: 'md',
    type: 'button',
  },
)
const element = ref<HTMLButtonElement>()
defineExpose({
  focus: () => element.value?.focus(),
  get element() {
    return element.value
  },
})
</script>
<template>
  <button
    ref="element"
    :type="type"
    class="ui-button"
    :class="[
      `ui-button--${variant}`,
      `ui-size--${size}`,
      `ui-tone--${tone}`,
      { 'ui-full-width': fullWidth },
    ]"
    :disabled="disabled || loading"
    :aria-busy="loading || undefined"
  >
    <span
      v-if="loading"
      class="ui-spinner"
      aria-hidden="true"
    />
    <slot
      v-else
      name="leading"
    />
    <slot />
    <slot name="trailing" />
  </button>
</template>
